import { toast } from "react-toastify";
import camelcaseKeys from "camelcase-keys";
import { STORAGE_KEYS } from "constants/appConstant";
import i18next from "i18next";
import snakecaseKeys from "snakecase-keys";
import store from "stores/configStore";
import { clearAuthData } from "stores/slices/auth";
import StorageHelper from "utils/storeHelper";

import axiosClient from "./axiosClient";

// const navigate = useNavigate();

const httpRequest = async ({
  url,
  method,
  params,
  data,
  successMessage,
  // ignoreErrorMessage = false,
  ...rest
}) => {
  let result;
  try {
    const response = await axiosClient.request({
      url,
      method,
      params: params && snakecaseKeys(params),
      data: data && (data instanceof FormData ? data : snakecaseKeys(data)),
      ...rest,
    });

    const { data: responseData, status } = response;
    if (successMessage && responseData && responseData.status === 200) {
      toast.success(i18next.t(successMessage));
    }

    if (responseData && responseData.status && responseData.status !== 200) {
      if (responseData.status === 412) {
        // StripeJS error
        toast.error(responseData.data);
      } else {
        // Other error
        toast.error(i18next.t(`error.message.${responseData.data}`));
      }
    }

    if (responseData && responseData.status === 401) {
      await StorageHelper.removeCookie(STORAGE_KEYS.token);
      StorageHelper.removeLocalItem(STORAGE_KEYS.user);
      store.dispatch(clearAuthData());
    }

    if (typeof responseData === "object" && !(responseData instanceof Blob)) {
      result = camelcaseKeys(responseData, { deep: true });
      return {
        status,
        ...result,
      };
    } else {
      result = responseData;
      return result;
    }
  } catch (error) {
    console.log("API Error: ", error);
    // // !ignoreErrorMessage &&
    //   toast.error(
    //     i18next.t(
    //       error.status
    //         ? `error.message.${error.status}`
    //         : `error.message.UNAUTHORIZED`
    //     )
    //   );

    if (error.status === 401 || !error.status) {
      await StorageHelper.removeCookie(STORAGE_KEYS.token);
      StorageHelper.removeLocalItem(STORAGE_KEYS.user);
      // console.log("vo day ne");
      store.dispatch(clearAuthData());
    }
    return error;
  }
};

export default httpRequest;
